import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { GlobalService } from '../services/global.service';
import { ApiService } from '../services/api.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.page.html',
  styleUrls: ['./menu.page.scss'],
})
export class MenuPage implements OnInit {
  selectedModel !: string | null;
  models = [
    { label: 'TTS', value: 'tts' },
    { label: 'STT', value: 'stt' },
  ];

  isAuthenticated : boolean = false;
  clientname: string | null | undefined;

  userRole: string  = 'normal'; // Default to 'normal' if not set
  

  index: { label: string }[] = [];
  text_category = [
     // { label: 'All', value: 'all' },
     { label: 'MozillaText', value: 'mozilla_text' },
     { label: 'Text', value: 'text' },
     { label: 'SurveyForms', value: 'surveyforms' },
     { label: 'Character', value: 'character' },
     { label: 'Number', value: 'number' },
     { label: 'Outbound', value: 'outbound' },
   ];
  
  constructor(private router:Router,private apiService:ApiService,private alertController: AlertController,private globalService:GlobalService) { }
  
  retriveAllTextFun(categoryListLabel: string, textCategoryList: string): Promise<void> {
    console.log("Cate on Localstorage is:", textCategoryList);
    const lang = 'nl';
  
    return new Promise<void>((resolve, reject) => {
      this.apiService.retriveText(lang, textCategoryList).subscribe(
        (response) => {
          console.log("Label is:", categoryListLabel);
          console.log("Response is:", response);
  
          const exists = this.index.some(item => item.label === categoryListLabel);
          if (!exists) {
            this.index.push({
              [categoryListLabel]: response.data,
              label: categoryListLabel,
            });
            // console.log(`Category '${categoryListLabel}' added to the index.`);
          } else {
            console.log(`Category '${categoryListLabel}' is already in the index.`);
          }
  
  
  
          // this.index.push({
          //   [categoryListLabel]: response,
          //   label: categoryListLabel,
          // });
  
          // console.log("Index updated:", this.index);
  
  
  
          resolve(); // Mark this function as completed
        },
        (err) => {
          console.error(err);
          reject(err); // Mark this function as failed
        }
      );
    });
  }


  ngOnInit() {
  const userName = localStorage.getItem('userName')?.trim();
  this.isAuthenticated = userName ? this.allowedClients.has(userName) : false;
  console.log(`Admin is ${this.isAuthenticated ? 'authenticated' : 'not authenticated'}`);

  // const promises = this.text_category.map(category =>
  //   this.retriveAllTextFun(category.label, category.value)
  // );
  this.globalService.setGlobalVariable(this.index);
  
  }

  ionViewWillEnter() {
    this.userRole = localStorage.getItem('userRole') || 'normal';
  }

  ionViewDidEnter(){
    
    // this.selectedModel = 'tts';
    // this.retriveTextFun();

  }
  goToModelInferencing() {
    this.router.navigate(['/modelinferencing']);

  }

  goToSentimentAnalysis() {
    this.router.navigate(['/sentiment-analysis-page']);

  }

  goToSTTAnalysis() {
    this.router.navigate(['/sttinferencing']);
  }

  goToClassificationAnalysis(){
    this.router.navigate(['/classificationinferencing']);
  }

  goToTextList(){
    this.router.navigate(['/text-list'])
  }

  goToDataCreation() {
    // this.router.navigate(['/home']);
    this.router.navigate(['/text-list'])


  }
  goToAddTextAndSound() {
    this.router.navigate(['/addsoundtext']);

  }

  goToAddSoundAndText(){
    this.router.navigate(['/addsoundfile']);
  }

  
  // Define the list of allowed client names
  allowedClients: Set<string> = new Set(['BAS','sabir', 'Harry', 'susan', 'joost', 'conny001', 'rb99', 'sushmita', 'rikesh']);
  //allowedClients: Set<string> = new Set(['BAS', 'Harry', 'joost', 'conny001', 'rb99', 'sushmita', 'rikesh']);

  async goToAdminPage() {
    this.clientname = localStorage.getItem('userName');
      // Check if clientname is in the allowedClients set
      if (this.clientname && this.allowedClients.has(this.clientname)) {
        this.router.navigate(['/admin']);
      } else {
        // Show a popup message if not allowed
        const alert = await this.alertController.create({
          header: 'Access Denied',
          message: 'Sorry, you do not have permission to access this page.',
          buttons: ['OK']
        });
        await alert.present();
      }
    }

  goToHistoryPage(){
    this.router.navigate(['/history']);
  }




  async confirmLogout() {
    // if(this.isRecording || this.hasUnsavedAudioData()){  
      const alert = await this.alertController.create({
            header: 'Confirm Logout',
            message: 'Are you sure you want to log out?',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        // Do nothing when the user cancels
                    }
                },
                {
                    text: 'Logout',
                    handler: async () => {
                        // this.stopRecordingOnly();
                        await this.LogoutFunction();
                    }
                }
            ]
        });

        await alert.present();
      // }else{
      //   await this.LogoutFunction();
      // }
  }

  async LogoutFunction(){
  
      try{
          this.globalService.logoutLoading();
          const res:any = await this.apiService.logoutUser().toPromise();
              

          localStorage.removeItem('authenticationKey');
          localStorage.removeItem('accent');
          localStorage.removeItem('age');
          localStorage.removeItem('gender');
          localStorage.removeItem('userId');
          localStorage.removeItem('userName');
          localStorage.removeItem('language');

          localStorage.removeItem('searchedText');
          localStorage.removeItem('selectedModel');
          localStorage.removeItem('selectedModelLanguageForTTS');
          localStorage.removeItem('selectedFilterValueForTTS');
          
          localStorage.removeItem('selectedOptionUser');
          localStorage.removeItem('textCategory');
          localStorage.removeItem('totalCountData');
          localStorage.removeItem('usersList');
          localStorage.removeItem('userRole');

          localStorage.removeItem('notRemoveModelInferencingData');
          localStorage.removeItem('numberOfRecordedText');
          localStorage.removeItem('textCategory');
          localStorage.removeItem('langCategory');

          // this.stopPlayingSound();
          // this.endClick = false;
          // this.pauseClick = false;
          // this.audioChunks = [];
          // this.recordedAudioUrl = '';
          // this.textFromServer = "";

          this.globalService.dismissLoading();
        
          this.router.navigate(['login']);



        
      
      }catch(error){
        console.log("Error:", error);
        // this.globalService.dismissLoading();
        this.router.navigate(['login']);

      }
      
  };

  goToAllHistory(){
    this.router.navigate(['/allhistory']);
  }


  

}
